import { render, staticRenderFns } from "./GsLinkedTemplates.vue?vue&type=template&id=c8327bd4&"
import script from "./GsLinkedTemplates.vue?vue&type=script&lang=js&"
export * from "./GsLinkedTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports